import React from "react";

import HGraph from "components/Custom/HGraph";

import { GRAPH_TYPES } from "common/config";

const StackedBar = (props: any) => {
  const { height, data } = props;

  const stackedChart = data.stackedBar;

  const series = stackedChart.data;
  const categories = stackedChart.category;
  console.log("stack", categories);

  return (
    <React.Fragment>
      <div className="graphs">
        <HGraph
          width={"100%"}
          height={height}
          type={GRAPH_TYPES.STACKED_BAR}
          float={"right"}
          xAxis={categories}
          yAxis={""}
          title={" "}
          series={series}
          exportTitle={" "}
          xAxisTitle="Months"
          yAxisTitle="Leads"
        />
      </div>
    </React.Fragment>
  );
};

export default StackedBar;
